import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Views
import { FrontpageComponent } from './components/frontpage/frontpage.component';



const routes: Routes = [
  { path: '', pathMatch: 'full', component: FrontpageComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}